import { FilterHierarchyFieldsGroupOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterName } from 'src/plp/components/FilterName/FilterName';
import { PlpFiltersMake } from '../components/PlpFiltersMake/PlpFiltersMake';
import { IconMakeModel } from 'src/general/Icons/IconMakeModel';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = PlpHierarchyFilterItemProps<FilterHierarchyFieldsGroupOption>;

export const FilterMakeModel = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'makeModel';
  const header = (
    <FilterName icon={<IconMakeModel />} label="Make & Model" showNotificationBadge={showNotificationBadge} />
  );
  const content = (
    <PlpFiltersMake options={options} subCategoryLabel="Model" currentFilters={currentFilters} {...props} />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
